import React from 'react'
import Button from '../../Button/Button'
import './AddSlotPopupStyle.css'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import TimePicker from "rc-time-picker-date-fns";
import "rc-time-picker-date-fns/assets/index.css";
import ToggleButton from '../../ToggleButton/ToggleButton'
import InputField from '../../InputField/InputField';
import moment from 'moment/moment';

const AddSlotPopup = ({ isActive, setIsActive, now, format, onChange, handleClose, daysInAWeek, dateRange, selectedWeekDays, timeRangeCount, setTimeRangeCount, interviewTime, setInterviewTime, handleCheckboxToggle, handleTimeFromChange, handleTimeToChange, handleTimeSlotRemove, handleSave, handleDiscard }) => {
    return (
        <div className={`popupWrapper addSlotWrapper  ${isActive && "active"}`}>
            <div className="AddpopupContainer">
                <div className="AddpopupHeader">
                    <span className="close"><img src="/assets/svg/close.svg" alt="" onClick={handleClose} /></span>
                </div>
                <div className="popupBody">
                    <div className="Addheadingwrapper">
                        <h3>Add Slot</h3>
                    </div>
                    <div className="AdminFormContentwrapper flexbox">

                        <div className="slotLeft">
                            <small className="AddsmallHeading">Set Weekly hours</small>
                            <Calendar className={'mt-10'} selectRange value={dateRange} onChange={onChange} minDate={new Date(moment().add(1, "day"))} maxDate={new Date(moment().add(1, "month"))} />
                            <div className="timeAlert flexbox mt-10">
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.00016 2.11719C4.59441 2.11719 1.8335 4.8781 1.8335 8.28385C1.8335 11.6896 4.59441 14.4505 8.00016 14.4505C11.4059 14.4505 14.1668 11.6896 14.1668 8.28385C14.1668 4.8781 11.4059 2.11719 8.00016 2.11719ZM0.833496 8.28385C0.833496 4.32581 4.04212 1.11719 8.00016 1.11719C11.9582 1.11719 15.1668 4.32581 15.1668 8.28385C15.1668 12.2419 11.9582 15.4505 8.00016 15.4505C4.04212 15.4505 0.833496 12.2419 0.833496 8.28385ZM8.00016 5.11719C8.27631 5.11719 8.50016 5.34105 8.50016 5.61719V8.28385C8.50016 8.56 8.27631 8.78385 8.00016 8.78385C7.72402 8.78385 7.50016 8.56 7.50016 8.28385V5.61719C7.50016 5.34105 7.72402 5.11719 8.00016 5.11719ZM7.50016 10.9505C7.50016 10.6744 7.72402 10.4505 8.00016 10.4505H8.00683C8.28297 10.4505 8.50683 10.6744 8.50683 10.9505C8.50683 11.2267 8.28297 11.4505 8.00683 11.4505H8.00016C7.72402 11.4505 7.50016 11.2267 7.50016 10.9505Z" fill="#E53935" />
                                </svg>
                                Time Slots will be of 30 min
                            </div>
                        </div>

                        <div className="slotRight">
                            <small className="AddsmallHeading">Set Weekly hours</small>
                            <div className="slotsWrapBox mt-10">


                            {daysInAWeek?.map((day, index) => (
                                <div className="slotsBox flexbox" key={index}>
                                <div className="toggleTime flexbox">
                                   <div className='flex gap-10'>
                                   <ToggleButton checked={selectedWeekDays.includes(day)} onChange={() => handleCheckboxToggle(day)} />
                                    <div className="toggleDay">{day.toUpperCase()}</div>
                                   </div>
                                 {selectedWeekDays?.includes(day) ? 
                                 <div className='flex gap-20 WeeklyHoursChart'>
                                  <div className='WeeklytimeSlotedata'>
                                  {timeRangeCount[day]?.map((j,i) => (
                                        <>
                                        <div className="dateSelectors">
                                            <div className="timeSlotPack flexbox gap-10">
                                            <TimePicker
                                                showSecond={false}
                                                defaultValue={now}
                                                value={interviewTime[day][i]?.from}
                                                className="xxx"
                                                onChange={(e) =>
                                                    handleTimeFromChange(e, day, i)
                                                }
                                                format={format}
                                                use12Hours
                                                minuteStep={10}
                                            />
                                                -
                                                <TimePicker
                                                    showSecond={false}
                                                    //   defaultValue={now}
                                                    value={interviewTime[day][i]?.to}
                                                    className="xxx"
                                                    onChange={(e) =>
                                                        handleTimeToChange(e, day, i)
                                                    }
                                                    format={format}
                                                    use12Hours
                                                    minuteStep={10}
                                                />
                                            </div>
                                        </div>

                                        <div className="toggleSwitchWrap flexbox gap15 pointer" onClick={(e) => handleTimeSlotRemove(day, i)}>
                                            <img src="/assets/svg/Redtrash.svg" alt="" />
                                        </div>
                                        </>
                                    )) }
                                  </div>
                                       {selectedWeekDays.includes(day) && <div onClick={() => {
                                                setTimeRangeCount({
                                                    ...timeRangeCount,
                                                    [day]: [...timeRangeCount[day], 0],
                                                });
                                                setInterviewTime({
                                                    ...interviewTime,
                                                    [day]: [
                                                        ...interviewTime[day],
                                                        { from: now, to: now },
                                                    ],
                                                });
                                            }}>
                                            <div className="toggleSwitchWrap flexbox gap15 pointer">
                                                <button className={'iconButton buttontext'}><img src='/assets/svg/plus-circle.svg' /></button>
                                            </div>
                                       </div>}
                                 </div> : <p className='text'>Unavailable</p>}
                                </div>
                                
                            </div>
                            ))}

                            </div>
                        </div>

                    </div>

                </div>
                <div className="AddFooterAdminPopup flex-center gap-10">
                    <Button className={'GreyFillButton buttontext'} name={'Discard'} onClick={handleDiscard}/>
                    <Button transparent={true} className={' BlueFillButton buttontext'} name={'Confirm'} onClick={handleSave} />
                </div>
            </div>
        </div>
    )
}

export default AddSlotPopup